'use client';

import { SectionBar } from '../SectionBar';
import { type FC, type ReactNode } from 'react';

interface CompletedItemsSectionProps {
  children: ReactNode;
  completedCount: number;
}

export const CompletedItemsSection: FC<CompletedItemsSectionProps> = ({
  children,
  completedCount,
}) => {
  if (!completedCount) {
    return null;
  }

  return (
    <SectionBar title="Completed" count={completedCount} color="success">
      {children}
    </SectionBar>
  );
};
